import { Box } from "@mui/material";

import { useAppSelector } from "app/redux-store-interactions";
import {
    AdvancedFeaturesToolbar,
    // MeasureMenuToolbar,
    // MeasurePickerToolbar,
    PinsToolbar,
    SettingsToolbar,
    ToolModeConfirmationToolbar,
    ToolsMenuToolbar,
    UndoRedoToolbar,
} from "components/toolbars";
import { CurrentModeToolbar } from "components/toolbars/implementations/CurrentModeToolbar";
import { OverflowToolbar } from "components/toolbars/implementations/OverflowToolbar";
import { ToolbarColumn } from "components/toolbars/ToolbarColumn";
import { AxisSphere } from "features/axisSphere/AxisSphere";
import { useNonMarkerUIIsHidden } from "features/markers/markerCreationUtils";
import { selectPicker } from "features/render";
import { selectIsAxisSphereVisible } from "slices/explorer";
import { ProcoreToolMode, selectActiveToolMode } from "slices/procoreUx";

import { ToolSettings } from "./toolSettings";

const columnFlexStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
} as const;

export function QuickAccessMenu() {
    const picker = useAppSelector(selectPicker);
    const isAxisSphereVisible = useAppSelector(selectIsAxisSphereVisible);
    const nonMarkerUIIsHidden = useNonMarkerUIIsHidden();
    const activeToolMode = useAppSelector(selectActiveToolMode);

    return (
        <Box
            sx={{
                position: "absolute",
                right: "8px",
                top: "8px",
                pointerEvents: "none",
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "start",
                gap: "8px",
            }}
        >
            <ToolbarColumn>
                <PinsToolbar picker={picker} id="pins-toolbar-close" />
                <Box
                    sx={{
                        ...columnFlexStyles,
                        visibility: nonMarkerUIIsHidden ? "hidden" : undefined,
                        pointerEvents: nonMarkerUIIsHidden ? "none" : undefined,
                    }}
                >
                    <AdvancedFeaturesToolbar />
                    <ToolModeConfirmationToolbar />
                    <ToolSettings />
                    <CurrentModeToolbar id="current-mode-toolbar" />
                    <OverflowToolbar id="overflow-toolbar" />
                    {activeToolMode === ProcoreToolMode.Default && <ToolsMenuToolbar id="quick-access-tools-menu" />}
                    <UndoRedoToolbar id="quick-access-undo-redo" />
                    <SettingsToolbar id="quick-access-settings" />
                </Box>
            </ToolbarColumn>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    alignItems: "flex-end",
                }}
            >
                {isAxisSphereVisible && <AxisSphere />}
            </Box>
        </Box>
    );
}
